export enum FILE_TYPE {
    ASSEMBLY_SIGNATURE = 302,
    ASSEMBLY_PROTOCOL = 313,
    EXTERNAL_AGENDAFILES = 381,
    INCIDENT_FILE = 500,
    // TICKET IMAGE_TYPE SECTION
    DAMAGE = 501,
    SERIALNUMBER = 502,
    PRODUCTIONNUMBER = 503,
    KEY = 504,
    DOCUMENT = 505,
    // TICKET IMAGE_TYPE END SECTION
    INCIDENT_ATTACHMENT = 506,
    INVOICE = 600,
    INPUTWORKFLOW_FILE = 603,
    INVOICE_ATTACHMENT = 604,
    NEWS_EXTERNAL_ATTACHMENT = 605
}

export enum FILE_STATE {
    NONE,
    NEW,
    LOADED_FROM_DB,
    SAVED_TO_DB,
    HAS_CHANGED,
    WAS_DELETED
}

export enum FILE_ORIGIN {
    CLOUD = 1,
    ERP = 2,
    DMS = 3,
    EMONITOR = 4
}

export enum FILE_ENTITY {
    CRED_INVOICES = "cred.invoices",
    TICKET_INCIDENTS = "ticket.incidents",
    COND_ASSEMBLY = "cond.assemblys",
    COND_SIGNATURES = "cond.signatures",
    COND_AGENDAITEMS = "cond.agendaitems",
    NEWS_ITEM = "news.news"
}
